var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongJingshi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.502L14.335 13.5H1.665L8 2.502z",
    stroke: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5v2.8",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 11.4a.6.6 0 11-1.2 0 .6.6 0 011.2 0z",
    fill: "#3F465C"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMi41MDE3NkwxNC4zMzUgMTMuNUgxLjY2NTAxTDggMi41MDE3NloiIHN0cm9rZT0iIzNGNDY1QyIvPgo8cGF0aCBkPSJNOCA2LjVWOS4zIiBzdHJva2U9IiMzRjQ2NUMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNOC41OTk0MSAxMS40QzguNTk5NDEgMTEuNzMxNCA4LjMzMDc4IDEyIDcuOTk5NDEgMTJDNy42NjgwNCAxMiA3LjM5OTQxIDExLjczMTQgNy4zOTk0MSAxMS40QzcuMzk5NDEgMTEuMDY4NyA3LjY2ODA0IDEwLjggNy45OTk0MSAxMC44QzguMzMwNzggMTAuOCA4LjU5OTQxIDExLjA2ODcgOC41OTk0MSAxMS40WiIgZmlsbD0iIzNGNDY1QyIvPgo8L3N2Zz4K";
export { SvgTongyongJingshi as ReactComponent };